import Dispatcher from "./Dispatcher.js";
import HttpError from "./HttpError.js";
import Auth from "./Auth.js";
//import Farm from "./Farm.js";
//import Crop from "./Crop.js";
import Settings from "./Settings.js";
import moment from 'moment';
import cache from "./cache.js";


class Api extends Dispatcher {
	isdev() {
		return window.location.hostname.toLowerCase().includes('.dev.');
	}

	constructor() {
		super();
		if (this.isdev())
			this.location = 'https://dev7.alteredeffect.com/people/karen/lull7/';
		else 
			this.location = 'https://dev7.alteredeffect.com/farm2table/api/';
			
		this.auth = new Auth(this);
		//this.farm = new Farm(this);
		//this.crop = new Crop(this);
		//this.auth = {};
		this.settings = new Settings(this);
		
		
		this.errorFn = null;
		this.successFn = null;
		this.lastLoggedOutError = 0;
		
		this.success = this.success.bind(this);
		this.error = this.error.bind(this);
		this.handleExceptions = this.handleExceptions.bind(this);
	}

	getHeaders(additional = {}) {
		let headers = {credentials: 'same-origin'};
		for(var prop in additional)
			headers[prop] = additional[prop];
		
		if (this.auth.sid) {
			headers['headers'] = {Authorization: 'Bearer ' + this.auth.sid}
		}
		return headers;
	}
	
	async fetcher(url, headers) {
		let response = await fetch(url, headers); 
		if (response.status === 200) return response.json();
		let data = await response.text() || response.statusText;
		try {
			data = JSON.parse(data);
			if (data.hasOwnProperty('description'))
				data = data.description;
		} catch(e) {

		}
		throw new HttpError(response.status, data);
	}
	
	
	// If we don't want to cache it, we can just call api.invalidate(endpoint) right after the get call
	get(endpoint) {
		this.invalidate(endpoint);
		return this.getsoft(endpoint);
	}

	getsoft(endpoint) {
		if (!cache.has('api_get_' + endpoint))
			cache.set('api_get_' + endpoint, this.fetcher(this.location + endpoint, this.getHeaders()));
		return cache.get('api_get_' + endpoint);
	}
	
	invalidate(endpoint) {
		console.log("Invalidating api_get_" + endpoint);
		cache.clear('api_get_' + endpoint);
	}


	post(endpoint, params) {
		const data = new FormData();
		for (let prop in params) {
			if (params.hasOwnProperty(prop)) {
				data.append(prop, params[prop]);
			}
		}

		let headers = this.getHeaders({
			method: "POST",
			body: data
		});
		
		this.invalidate(endpoint);
		return this.fetcher(this.location + endpoint, headers);
	}


	async put(endpoint, params) {
		let headers = this.getHeaders({
			method: "PUT",
			body: JSON.stringify(params)
		});
		
		this.invalidate(endpoint);
		let e = endpoint.split("/");
		e.pop(); // Invalidate the non-ID version as well
		this.invalidate(e.join("/"));
		return this.fetcher(this.location + endpoint, headers);
	}
	
	
	async del(endpoint, params = {}) {
		let headers = this.getHeaders({
			method: "DELETE",
			body: JSON.stringify(params)
		});
		headers['body'] = JSON.stringify(params);
		
		this.invalidate(endpoint);
		return this.fetcher(this.location + endpoint, headers);
	}

	
	
	
	success(msg) {
		if (this.successFn != null)
			this.successFn(msg);
	}
	
	error(msg) {
		if (this.errorFn != null)
			this.errorFn(msg);
	}
	
	date(datestr) {
		if (datestr === null || typeof datestr === 'undefined' || datestr.length !== 10 || datestr === '0000-00-00')
			return null;
		
		var d = new Date();
		// console.log("date", new Date(datestr + d.toISOString().slice(10)));
		// console.log("moment", moment(datestr));
		// console.log("moment-date", moment(datestr).toDate());
		return moment(datestr).toDate();
		//return new Date(datestr + d.toISOString().slice(10)); // Append the current timestring because ugh
	}
	
	
	handleExceptions(e) {
		if (e instanceof HttpError && e.code === 401) {
			const now = (new Date()).getTime();
			if (now > this.lastLoggedOutError + 5000) {
				this.lastLoggedOutError = now;
			} else {
				// If it's been to soon, jump out early
				return;
			}
		}

		if (e instanceof SyntaxError && e.message.includes('JSON')) {
			this.error({message: "The server has sent back data in an unexpected format. Are you in debug mode?"});
		} else {
			if(e.code === 401) {
				this.auth.loggedout();
				console.log("Log in error");
			}
			// console.log(e.message);
			this.error(e);
			//throw e;
		}
	}
	
	
	isCurrentlyDisabled(dateField) {
		if (dateField !== null) {
			if (moment(dateField) < cache.get('daterange.end')) {
				return true;
			}
		}
		return false;
	}
}

// eslint-disable-next-line no-extend-native
Date.prototype.api = function() {
	//return this.toISOString().slice(0, 10);
	return this.getFullYear() + '-' + String(this.getMonth()+1).padStart(2, "0") + '-' + this.getDate()
}


// eslint-disable-next-line no-extend-native
Number.prototype.moneyFormat = function(decimalCount = 2, decimal = ".", thousands = ",") {
  let amount = this;
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};


var api = new Api();
window.api = api;
export default api;
